// @mui
import type { IconButtonProps } from '@mui/material';

import { IconButton } from '@mui/material';

// components
import Iconify from '../../../components/iconify';
import { useSettingsContext } from '../../../components/settings';
// config
import { NAV } from '../../../config-global';
// hooks
import useResponsive from '../../../hooks/useResponsive';

const NavToggleButton = ({ sx, ...other }: IconButtonProps) => {
  const { onToggleLayout, themeLayout } = useSettingsContext();

  const isDesktop = useResponsive('up', 'lg');

  if (!isDesktop) {
    return null;
  }

  return (
    <IconButton
      onClick={onToggleLayout}
      size="small"
      sx={{
        '&:hover': {
          bgcolor: 'background.default',
        },
        bgcolor: 'background.default',
        border: (theme) => `dashed 1px ${theme.palette.divider}`,
        left: NAV.W_DASHBOARD - 12,
        p: 0.5,
        position: 'fixed',
        top: 32,
        zIndex: (theme) => theme.zIndex.appBar + 1,
        ...sx,
      }}
      {...other}
    >
      <Iconify
        icon={
          themeLayout === 'vertical'
            ? 'eva:arrow-ios-back-fill'
            : 'eva:arrow-ios-forward-fill'
        }
        width={16}
      />
    </IconButton>
  );
};

export default NavToggleButton;
